import { Box, BoxProps } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';

type CardListRowProps = {
    hoverable?: boolean;
} & BoxProps;

export const CardListRow: FunctionComponent<
    PropsWithChildren<CardListRowProps>
> = ({ hoverable, children, sx: sxProps, ...rest }) => (
    <Box
        sx={[
            (theme) => ({
                p: 4,
                pl: 6,
                width: '100%',

                transition: theme.transitions.create(['background-color'], {
                    duration: theme.transitions.duration.shortest,
                    easing: theme.transitions.easing.easeInOut,
                }),

                ...(hoverable && {
                    '&:hover': {
                        // neutral is only typed by the apps' theme augmentation
                        backgroundColor: (
                            theme.palette as unknown as {
                                neutral: Record<number, string>;
                            }
                        ).neutral[200],
                        cursor: 'pointer',
                    },
                }),
            }),
            ...(Array.isArray(sxProps) ? sxProps : [sxProps]),
        ]}
        {...rest}
    >
        {children}
    </Box>
);
